
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSoundOnPressed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 33,
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#soundOnPressed_90b2fcfbd90b8dfe__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.165 14.86V4.916c0-1.128-1.312-1.746-2.182-1.028L16 8m-6.667 2.296H8.012c-.737 0-1.334.597-1.334 1.333v8.046c0 .737.597 1.334 1.334 1.334h4.708c.32 0 .63.115.873.326l7.365 6.386c.864.749 2.207.136 2.207-1.007v-2.302m3.757-.62L8.209 4.8",
  stroke: "#fff",
  strokeWidth: 2.5,
  strokeLinecap: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "soundOnPressed_90b2fcfbd90b8dfe__a",
  x: 3.246,
  y: 0.873,
  width: 27.107,
  height: 31.338,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.727
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.091
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_15942_165944"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_15942_165944",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"32\" height=\"33\" viewBox=\"0 0 32 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g filter=\"url(#filter0_d_15942_165944)\">\r\n<path d=\"M23.1652 14.8604V4.91592C23.1652 3.78846 21.8528 3.16993 20.9832 3.88753L15.9998 7.99992M9.33317 10.2956H8.01156C7.27518 10.2956 6.67822 10.8926 6.67822 11.6289V19.6753C6.67822 20.4117 7.27518 21.0087 8.01156 21.0087H12.7198C13.0407 21.0087 13.3508 21.1244 13.5933 21.3346L20.9583 27.7211C21.8217 28.4698 23.1652 27.8565 23.1652 26.7138V24.4115M26.9217 23.7913L8.20866 4.79996\" stroke=\"white\" stroke-width=\"2.5\" stroke-linecap=\"round\"/>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_15942_165944\" x=\"3.2464\" y=\"0.873091\" width=\"27.1073\" height=\"31.338\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"0.727273\"/>\r\n<feGaussianBlur stdDeviation=\"1.09091\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_15942_165944\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_15942_165944\" result=\"shape\"/>\r\n</filter>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/soundOnPressed.90b2fcfbd90b8dfe327765ebb1b0664d.svg"),
        {
          React: SvgSoundOnPressed,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      